import $ from 'jquery';

import {
	toggleFooterMobileLinks,
	isFloatingFooterMenu,
	handleFooterMobileVisibility,
} from './floating-menu.js';

const $overlay = $('.js-overlay');

// Check overlay visibility
export const isOverlayVisible = () => {
	return $overlay.hasClass('is-active');
};

export const setOverlayVisibility = (isVisible) => {
	$overlay.toggleClass('is-active', isVisible);
};

// Set Body data attrebute
export const setBodyAttr = (bodyAttr = '') => {
	$('body').attr('data-popup-type', bodyAttr);
};

// Lock body scroll
export const setLockScroll = (lock = true) => {
	$('html').toggleClass('locked', lock);
};

// Lock body scroll
export const isScrollLocked = () => {
	return $('html').hasClass('locked');
};

// Toogle header Mobile Accordion Navigation
export const toogleNavAccordion = ($this) => {
	const $parent = $this.parent();
	const $submenu = $parent.find('.sub-menu').first();

	// Close all other sub-menus
	$('.header-nav-mobile .sub-menu').not($submenu).slideUp();
	$('.header-nav-mobile .menu-item-has-children')
		.not($parent)
		.removeClass('active');

	// Toggle current sub-menu
	$submenu.slideToggle();
	$parent.toggleClass('active');
};

// Toggle menu function
export const toggleMenu = () => {
	const burgetStatus = $('.js-burger').hasClass('is-active');
	const searchStatus = $('.js-search-toggle').hasClass('is-closed');

	$('.header-mobile, .js-search-toggle, .js-burger').toggleClass('is-active');

	// Check if search is open and search is open
	if (isOverlayVisible() === false && !searchStatus) {
		setOverlayVisibility(true);
		setBodyAttr('mobile-menu-type');
		setLockScroll(true);
		handleFooterMobileVisibility(false);
	}

	// Check if burger menu is open (form mobile)
	if (burgetStatus && !searchStatus) {
		setOverlayVisibility(false);
		setLockScroll(false);
	}

	if (searchStatus) {
		handleFooterMobileVisibility(false);
		setLockScroll(true);
	}

	// to set header on top z-index
	if (!searchStatus) {
		$('.header').toggleClass('is-active');
	}
};

// Toggle popup function
export const togglePopup = (
	toggleType = false,
	$this = false,
	isFooterLink = false
) => {
	const currentType = $('body').attr('data-popup-type');
	const $elToShow = $('.' + toggleType);

	// Check if toggle type is empty (Overlay clicked)
	if (!toggleType) {
		setOverlayVisibility(false);
		$(`.${currentType}`).removeClass('is-active');
		toggleFooterMobileLinks();
		setBodyAttr();
		setLockScroll(false);
		return;
	}

	// Check if toggle type is same as current type
	if (toggleType === currentType) {
		setOverlayVisibility(false);
		$elToShow.removeClass('is-active');
		toggleFooterMobileLinks();
		setBodyAttr();
		setLockScroll(false);
		return;
	}

	// Check if overlay is active
	if (isOverlayVisible() === false || currentType) {
		setOverlayVisibility(true);
		$elToShow.addClass('is-active');
		setBodyAttr(toggleType);
		setLockScroll(true);
	}

	// Check if footer floanting link is clicked
	if (isFooterLink && $this) {
		toggleFooterMobileLinks($this, toggleType);
	}

	// If clicked NEXY footer floanting link hide/show popup and set body attr
	if (isFooterLink && currentType !== toggleType && currentType !== '') {
		setBodyAttr(toggleType);
		$(`.${currentType}`).removeClass('is-active');
		$elToShow.addClass('is-active');
	}
};

// Handle overlay visibility on search
export const handleOvelrayVisibility = () => {
	setOverlayVisibility(true);
	handleFooterMobileVisibility(isFloatingFooterMenu());
	setBodyAttr('mobile-menu-type', true);
	$('header').addClass('is-active');
};

export function hideElementOnScroll(className) {
	let lastScrollTop = 0;
	const element = document.querySelector(`.${className}`);

	if (!element) {
		return;
	} // Exit if element doesn't exist

	window.addEventListener('scroll', function () {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		if (scrollTop > lastScrollTop + 20) {
			// ✅ Hide on scroll down
			element.style.transition = 'bottom 0.3s ease-out, opacity 0.3s ease-out';
			element.style.bottom = '-70px';
			element.style.opacity = '0';
		} else if (scrollTop < lastScrollTop) {
			// ✅ Show on scroll up
			element.style.bottom = '0';
			element.style.opacity = '1';
		}

		lastScrollTop = scrollTop;
	});
}

/**
 * Check window size
 *
 * @param  size
 */
export const checkWindowSize = (size = 992) => {
	if ($(window).width() <= size) {
		return true;
	}
	return false;
};

// Open mini cart
export const openMiniCart = () => {
	$('.site-header').removeClass('is-active');

	const $this = $('.js-mini-cart-icon, .js-close-cart');
	const toggleType = 'js-side-cart';
	togglePopup(toggleType, $this);
	toggleFooterMobileLinks($this);
};
